export default "__VITE_ASSET__b303e0d6__"